declare namespace $ {

	export class $shm_hitalama_map_widget_float_notebook_edit extends $shm_hitalama_map_widget_float_notebook {
	}
	
}

//# sourceMappingURL=edit.view.tree.d.ts.map